/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
import React from "react";
import { useTranslation } from "react-i18next";

import { TableRow, TableHeader } from ".";

import { Table, Thead, Tbody, Tr, Th } from "../components";
import { TableAction } from "../constants/table";

interface CustomTableProps {
  data: any[];
  columns: any[];
  handleViewDetails: Function;
  sortAction: Function;
  sortOrder: string;
  getActions: (rData: any) => TableAction[];
  [extraProps: string]: any;
}

const CustomTable: React.FC<CustomTableProps> = ({
  data,
  columns,
  sortAction,
  sortOrder,
  orderBy,
  getActions,
  handleViewDetails,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Table {...props}>
        <Thead>
          <Tr>
            {columns.length > 0 &&
              columns.map((c, i) => (
                <TableHeader
                  key={i}
                  tableColumn={c}
                  sortable={c.sortable}
                  sortOrder={sortOrder}
                  sortAction={sortAction}
                  orderBy={orderBy}>
                  {t(c.title)}
                </TableHeader>
              ))}
          </Tr>
        </Thead>
        <Tbody>
          {data &&
            data.map((row) => (
              <TableRow
                key={row[columns[0].idProp]}
                rData={row}
                columns={columns}
                actions={getActions(row)}
                handleViewDetails={handleViewDetails}
              />
            ))}
        </Tbody>
      </Table>
    </>
  );
};

export default CustomTable;
